<template>
  <div class="masthead" :class="mastHeadClassName">
    <div class="masthead__image">
      <img v-if="imageUrl" :src="imageUrl" alt="" ref="mastheadRef" />
      <div class="masthead__shade">
        <div
          class="text-container container"
          :class="{
            'text-container--bottom-left': textAlign === 'bottomLeft',
            'text-container--variant1': variant === 'variant1',
          }"
        >
          <div v-if="signature" class="masthead__signature">
            {{ signature }}
          </div>
          <h1 v-if="title" class="masthead__title">
            {{ title }}
          </h1>
          <h2 v-if="description" class="masthead__description">
            {{ description }}
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Masthead",
  props: {
    variant: {
      type: String,
    },
    imageUrl: {
      type: String,
      default:
        "https://d20knvk822eu5a.cloudfront.net/static-assets/booking-portal/aqua-mare-beach-club.webp",
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    signature: {
      type: String,
    },
    textAlign: {
      validator(value, props) {
        // The value must match one of these strings
        return ["center", "bottomLeft"].includes(value);
      },
      default: "center",
    },
    mastHeadType: {
      type: String,
      default: "default",
    },
    // If true, the text container's top will be adjusted so that it is vertically aligned center on the area without navbar
    hasNavbarOverlay: {
      type: Boolean,
    },
  },
  computed: {
    mastHeadClassName() {
      return this.hasNavbarOverlay
        ? `masthead--${this.mastHeadType} masthead--navbar-overlay`
        : `masthead--${this.mastHeadType}`;
    },
  },
  methods: {
    onScroll() {
      // const ref = this.$refs.mastheadRef;
      // const rect = ref.getBoundingClientRect();
      // const win = ref.ownerDocument.defaultView;
      // const offsetTop = rect.top + win.scrollY;

      const y =
        document.documentElement.scrollTop || document.body.scrollTop || 0;
      const mastheadHeight = document.body.clientWidth >= 768 ? 668 : 400;
      const scrollRatio = Math.min(y, mastheadHeight) / mastheadHeight;

      const min = 1.0;
      const max = 1.5;
      const interpolated = min + scrollRatio * (max - min);
      this.$refs.mastheadRef.style.transform = `scale(${interpolated}) translateZ(0px)`;
    },
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
<style lang="scss" scoped>
@import "../../scss/typography.scss";
@import "../../scss/color.scss";
@import "../../scss/mixin.scss";

.masthead {
  position: relative;
  display: flex;
  z-index: 1;
  overflow: hidden;

  &--search {
    height: 100vh;

    @include md {
      height: 90vh;
      height: 90svh;
    }
    @include lg {
      height: 75vh;
      height: 75svh;
    }

    @include md-down {
      .masthead__shade {
        justify-content: flex-start;
      }

      .text-container {
        $mobileNavbarHeight: 104px;
        $availabilitySearchBar: 261px + 76px + 16px;
        margin-top: calc(
          $mobileNavbarHeight +
            (100vh - $mobileNavbarHeight - $availabilitySearchBar) / 2
        );
        transform: translateY(-50%);
      }
    }
  }

  &--default {
    height: 55vh;
    height: 55svh;
  }

  &--signup {
    height: 70vh;
    height: 70svh;
  }
}

.masthead__image {
  height: 100%;
  width: 100%;
  background: darkgray;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.masthead__shade {
  position: relative;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  //background: linear-gradient(
  //  0deg,
  //  rgba(0, 0, 0, 0.2) 0%,
  //  rgba(0, 0, 0, 0.2) 100%
  //);

  background: linear-gradient(rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0.5) 95%);
}

.masthead__signature {
  margin-bottom: 0.75rem;
  @include display-signature-small;
  color: $signature-100;

  @include lg {
    margin-bottom: 1rem;
  }
}

.masthead__title {
  @include display-headline;
  color: $white-100;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 62.5rem;
}

.masthead__description {
  @include global-paragraph-medium-regular;
  color: $white-100;
  margin-top: 0.75rem;
  margin-bottom: 0;
  max-width: 38.5rem;

  @include lg {
    margin-top: 1rem;
    width: 38.5rem;
  }
}

.text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  //padding-top: 1rem;
  //padding-bottom: 1rem;
  //margin-top: 78px; // hard-coded navbar's height, this is to achieve vertical center in the masthead area excluding navbar's height
  //opacity: 0;
  //animation: fadeInUp .6s .3s ease-in-out forwards;

  @include md {
    //padding: 0;
    //margin-top: 94px; // hard-coded navbar's height
  }

  @include lg {
    //padding: 0;
    //margin-top: 130px; // hard-coded navbar's height
  }

  &--bottom-left {
    //margin-left: 40px;
    margin-bottom: 54px;
    height: 100%;
    justify-content: flex-end;
    align-items: flex-start;
    text-align: left;

    @include md {
      //margin-left: 80px;
      margin-bottom: 94px;
    }
  }

  &--variant1 {
    .masthead__signature {
      font-size: 104px;
      order: 1;

      @include lg {
        margin-left: 540px;
      }
    }

    .masthead__description {
      align-items: center;
      order: -1;
      margin-top: 0;
      margin-bottom: 24px;

      @include sm-down {
        margin-bottom: 32px;
      }
    }
  }
}

.masthead--navbar-overlay {
  .text-container {
    @include lg {
      $navbar-height: 56px + 78px;
      margin-top: $navbar-height;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Masthead.vue